import React from 'react';
import { Radio } from 'antd';
import classnames from 'classnames';
import './Radio.scss';

function RadioContainer({
  datatestid,
  onChange,
  value,
  bordered = false,
  children,
  className,
  ...props
}) {
  const testid = datatestid ? `${datatestid}` : null;
  const name = props.name ? props.name : `${testid}-radioGroup`;
  const radioClassName = classnames(className, { bordered: bordered });

  return (
    <Radio.Group
      data-testid={testid}
      name={name}
      onChange={onChange}
      className={radioClassName}
      value={value}
      {...props}
    >
      {children}
    </Radio.Group>
  );
}

export { RadioContainer };
